// components/CodeBlock/CodeBlock.jsx

import { CopyButton } from '../../components';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

function CodeBlock({ code, language = 'bash' }) {
    return (
        <div style={{ position: 'relative' }}>
            <CopyButton text={code} />

            <SyntaxHighlighter
                style={dracula}
                language={language}
                PreTag="div"
                customStyle={{
                    margin: 0,
                    borderRadius: '8px',
                    padding: '1.25rem',
                    fontSize: '0.95rem',
                }}
            >
                {code}
            </SyntaxHighlighter>
        </div>
    );
}

export default CodeBlock;